import { render, staticRenderFns } from "./Forge.vue?vue&type=template&id=1b315414"
import script from "./Forge.vue?vue&type=script&lang=js"
export * from "./Forge.vue?vue&type=script&lang=js"
import style0 from "./Forge.vue?vue&type=style&index=0&id=1b315414&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports